import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContextLocationSearchString as selectContextLocationSearchStringInState, 
    setContextLocationSearchString as setContextLocationSearchStringInState
} from 'store/applicationSlice'

export const useContextLocationSearchString = () => {
    const dispatch = useAppDispatch()
    const contextLocationSearchStringFromState = useAppSelector(selectContextLocationSearchStringInState) 
    const selectContextLocationSearchString = contextLocationSearchStringFromState

    const setContextLocationSearchString = (contextLocation: any) => {
        dispatch(setContextLocationSearchStringInState(contextLocation))
    }
  
    return {
        selectContextLocationSearchString,
        setContextLocationSearchString
    }
}